'use client';

import { fromJS } from 'immutable';
import { usePathname, useRouter } from 'next/navigation';
import { useContext } from 'react';

import { Button } from 'components/ui/button';

import { StateContext } from '@/lib/StateProvider';
import authenticateThenRedirect from '@/lib/authenticateThenRedirect';
import { trackClick } from '@/lib/event_tracker';

function makeConversionCtaButtonOnClick(
  session,
  pathname,
  dispatch,
  router,
  queryParams,
  options
) {
  return async (_e) => {
    trackClick(session, pathname, 'Conversion CTA Button', options.properties);

    await authenticateThenRedirect(
      session,
      pathname,
      dispatch,
      router,
      queryParams
    );
  };
}

export default function CTAButton({
  sessionData,
  children,
  className,
  properties,
  freePlanSubscriberPath,
  paidPlanSubscriberPath,
}) {
  const session = fromJS(sessionData);
  const router = useRouter();
  const pathname = usePathname();
  const { dispatch } = useContext(StateContext);

  return (
    <Button
      size="none"
      className={className}
      onClick={makeConversionCtaButtonOnClick(
        session,
        pathname,
        dispatch,
        router,
        {
          freePlanSubscriberPath,
          paidPlanSubscriberPath,
        },
        {
          properties,
        }
      )}
    >
      {children}
    </Button>
  );
}
